import React from "react";
import { Application } from "interfaces/data";
import { Input } from "components/Input/Input";
import { TwoColumnsLayout } from "components/TwoColumnsLayout/TwoColumnsLayout";
import { useTranslation } from "react-i18next";
import { EditViewProps } from "components/EditBox/EditBox";
import { COUNTRIES } from "helpers/options";
import { Select } from "components/Select/Select";

export function EditCompanyAddress({ data, handleChange, errors }: EditViewProps<Application>) {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  return (
    <TwoColumnsLayout>
      <Input
        error={errors?.["companyAddress.industry"]}
        id="street"
        label={t("company:Street")}
        name="companyAddress.street"
        onChange={handleChange}
        type="text"
        value={data.companyAddress?.street}
        withError={!!errors?.["companyAddress.street"]}
      />
      <Input
        error={errors?.["companyAddress.number"]}
        id="number"
        label={t("company:Apt number")}
        name="companyAddress.number"
        onChange={handleChange}
        type="text"
        value={data.companyAddress?.number}
        withError={!!errors?.["companyAddress.number"]}
      />
      <Input
        error={errors?.["companyAddress.code"]}
        id="code"
        label={t("company:Code")}
        name="companyAddress.code"
        onChange={handleChange}
        type="text"
        value={data.companyAddress?.code}
        withError={!!errors?.["companyAddress.code"]}
      />
      <Input
        error={errors?.["companyAddress.city"]}
        id="city"
        label={t("company:City")}
        name="companyAddress.city"
        onChange={handleChange}
        type="text"
        value={data.companyAddress?.city}
        withError={!!errors?.["companyAddress.city"]}
      />
      <Select
        error={errors?.["companyAddress.country"]}
        id="country"
        label={t("company:Country")}
        name="companyAddress.country"
        onChange={handleChange}
        options={COUNTRIES}
        value={data.companyAddress?.country}
      />
    </TwoColumnsLayout>
  );
}
